import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Link from '@tiptap/extension-link';
import { ListKit } from '@tiptap/extension-list';
import Image from '@tiptap/extension-image';
import ImageResize from 'tiptap-extension-resize-image';
import { Footnotes, Footnote, FootnoteReference } from 'tiptap-footnotes';
import type { Extension } from '@tiptap/core';
import { ScriptMention, ScriptMode, SuggestionInsertMarkers } from '@narrativebench/editor-core';
import { EntityMention } from './entity-mention-extension';

export const listKitExtension = ListKit.configure({
  bulletList: {
    HTMLAttributes: { class: 'list-disc' },
  },
  orderedList: {
    HTMLAttributes: { class: 'list-decimal' },
  },
  taskList: {
    HTMLAttributes: {
      class: 'task-list',
    },
  },
  taskItem: {
    nested: true,
    HTMLAttributes: {
      class: 'task-item',
    },
  },
});

const readOnlyMentionSuggestion = {
  char: '@' as const,
  items: () => [],
  render: () => ({}),
};

export const createStaticEditorExtensions = (highlightExtension: Extension | any) => [
  StarterKit.configure({
    bulletList: false,
    orderedList: false,
    listItem: false,
    listKeymap: false,
    link: false,
    undoRedo: false,
    document: false,
  }) as any,
  Document.extend({
    content: 'block+ footnotes?',
  }),
  Image.configure({
    HTMLAttributes: {
      class: 'max-w-full h-auto',
    },
  }),
  ImageResize.configure({
    inline: true,
  }),
  listKitExtension,
  Link.configure({
    openOnClick: true,
    HTMLAttributes: {
      target: '_blank',
      rel: 'noopener noreferrer nofollow',
    },
  }),
  EntityMention.configure({
    HTMLAttributes: {
      class: 'mention',
    },
    suggestion: readOnlyMentionSuggestion,
  }),
  ScriptMention.configure({
    HTMLAttributes: {
      class: 'mention script-mention',
    },
    suggestion: readOnlyMentionSuggestion,
  }),
  ScriptMode.configure({
    getSetting: () => true,
  }),
  Footnotes,
  Footnote,
  FootnoteReference,
  highlightExtension,
  SuggestionInsertMarkers,
];


